<template>
    <span
        v-if="scrolled === true"
        v-on:click="scrollToTop()"
        class="scrollToTop"
    >
        <i
            class="fa-duotone fa-solid fa-circle-arrow-up"
            style="--fa-primary-color: #39b3d7; --fa-secondary-color: #39b3d7;"
        ></i>
    </span>
</template>

<script>
export default {
    name: 'scroll-to-top',
    data () {
        return {
            scrolled: false
        }
    },
    methods: {
        handleScroll () {
            this.scrolled = window.scrollY > 0
        },
        scrollToTop () {
            var element = document.getElementById("app")
            var top = element.offsetTop
            window.scrollTo(0, top)
        }
    },
    beforeMount () {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
    .scrollToTop {
        text-align:center;
        font-weight: bold;
        text-decoration: none;
        position:fixed;
        bottom:40px;
        right:40px;
        text-align: center;
        font-size: 68px;
        z-index: 999;
    }
</style>
